import { Modal, Select } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useGetOrganismRoomsQuery } from "store/services/teacher/classes.services";

const { Option } = Select;

const SelectClassroomModal = ({
    open,
    onClose,
    teacherId,
    onSelect,
}: any) => {

    const { user } = useSelector((state) => state.auth);
    const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(user?._id);
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const handleOk = () => {
        if (selectedId) {
            onSelect(selectedId);
        }
    };

    return (
        <Modal
            title="Choisir une classe"
            visible={open}
            onCancel={onClose}
            onOk={handleOk}
            okButtonProps={{ disabled: !selectedId }}
            okText="Valider"
            cancelText="Annuler"
        >
            {!loadingOrganismRooms && <Select
                placeholder="Sélectionner une classe"
                style={{ width: "100%" }}
                onChange={(value) => setSelectedId(value)}
            >
                {organismRooms?.data?.map((room: any) => (
                    <Option key={room._id} value={room._id}>
                        {room.title}
                    </Option>
                ))}
            </Select>}
        </Modal>
    );
};

export default SelectClassroomModal;
